import { authVar } from '@services/graphql/core';
import { useReactiveVar } from '@apollo/client';

export const useAuth = () => [useReactiveVar(authVar), authVar];
